import recommend from '@/pages/recommend'
export default {
    path: '/recommend',
    name: 'recommend',
    component: recommend,
    meta: {
        title: '小蛙推荐'
    }
}